

import axios from 'axios';
import apiClient from './apiClient';
const positionsApi = apiClient('');
// Базовый клиент, унаследованный от apiClient (с вашими настройками, URL, credentials и т.д.)
const inventoryClient = apiClient('');

const positionSettingsApi = {

    /**
     * Получить одну запись по ID
     * GET /positionSettings/:id
     * @param {number} id
     */
    async getPositionSettingById(id) {
        try {
            const response = await inventoryClient.get(`/positionSettings/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении настройки позиций с ID ${id}:`, error);
            throw error;
        }
    },





    /**
     * Получить все настройки позиций по promoType
     * GET /positionSettings/type/:promoType
     * @param {'onlyCrystals' | 'crystalsAndCrypto' | 'cryptoOnly'} promoType
     */
    async getPositionSettingsByPromoType(promoType) {
        try {
            const response = await inventoryClient.get(`/positionSettings/type/${promoType}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении настроек позиций для promoType "${promoType}":`, error);
            throw error;
        }
    },

    /**
     * (Опционально) Получить все записи positionSettings, отсортированные по gemId
     * GET /positionSettings/byGem/:gemId
     * @param {number} gemId
     */
    async getPositionSettingsByGemId(gemId) {
        try {
            const response = await inventoryClient.get(`/positionSettings/byGem/${gemId}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении настроек позиций для gemId ${gemId}:`, error);
            throw error;
        }
    }
};

export default positionSettingsApi;
